module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1109.b4018b15.jpg";